// extracted by mini-css-extract-plugin
export default {"CopyInput":"UiumOj0FfTw2M6YD1Flx","CopyIconContainer":"nHaXEAOcvMlG8SixWctY"};